module.exports = __webpack_public_path__ + "img/banner_id.56604576.png";